// import request from '@/utils/request';

import $x from '@/utils/$x';

//  获取品类级别
export async function getCategoryLevel(params) {
  return $x.post('/category/getCategoryLevelConfig', params);
}

//  查询分类树
export async function getCategoryTree(params) {
  return $x.post('/category/getLittaCategoryTree', params);
}

// 分类列表查询
export async function getCategoryList(params) {
  return $x.post('/category/getLittaCategoryList', params);
}
//  根据id查品类详情
export async function getCategoryDetail(params) {
  return $x.post('/category/getLittaCategoryById', params);
}
// 添加分类
export async function addCategory(params) {
  return $x.post('/category/addLittaCategory', params);
}

// 编辑保存分类
export async function editCategory(params) {
  return $x.post('/category/updateLittaCategory', params);
}

// 删除品类
export async function deleteCategory(params) {
  return $x.post('/category/enableOrDisablecategory', params);
}

// 编辑分类介绍
export async function editLittaCategoryIntro(params) {
  return $x.post('/category/editLittaCategoryIntro', params);
}

//查询分类信息
export async function getLittaCategoryInfo(params) {
  return $x.post('/category/getLittaCategoryInfo', params);
}


